import React, { useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Alert from "@mui/material/Alert";
import {
  useAuthState,
  useAuthDispatch,
  authenticate,
  checkSession,
  completeEnforcePasswordChange,
  verifyMFA
} from "../../Context";
import { useNavigate } from "react-router-dom";
import LoadingPage from "../Loading/Loading";
import LoginForm from "./LoginForm";
import ChangeDefaultPasswordForm from "./ChangeDefaultPasswordForm";
import MFAVerificationForm from "./MFAVerificationForm";
import Banner from "../Banner/Banner";
import { getEnvironmentFromBackendUrl } from "../../utils/utils";


export default function Login() {
  const navigate = useNavigate();
  const dispatch = useAuthDispatch();
  const { isAuthenticated, loading, newPasswordRequired, user, errorMessage, mfaRequired } =
    useAuthState();

  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  React.useEffect(() => {
    if (errorMessage) {
      setOpenSnackbar(true);
    }
  }, [errorMessage]);

  useEffect(() => {
    const verifySession = async () => {
      try {
        console.log("checking session");
        await checkSession(dispatch);
        console.log("session verified");
      } catch (err) {
        console.log(err.message);
      }

      // simulate slow checkSession call to visualize the loading page
      // try {
      //   await new Promise((resolve, reject) => {
      //     setTimeout(async () => {
      //       try {
      //         await checkSession(dispatch);
      //         resolve();
      //       } catch (err) {
      //         reject(err);
      //       }
      //     }, 3000);
      //   });
      // } catch (err) {
      //   console.log(err.message);
      // }
    };
    verifySession();
  }, [dispatch]);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/");
      dispatch({ type: "NAVIGATE", payload: "/" });
    }
  }, [isAuthenticated, navigate, dispatch]);

  useEffect(() => {
    // Automatically close the alert
    if (newPasswordRequired || mfaRequired) {
      dispatch({ type: "CLEAR_ERROR" }); // clear the error message
      setOpenSnackbar(false);
    }
  }, [newPasswordRequired, mfaRequired, dispatch]);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({ type: "CLEAR_ERROR" }); // clear the error message
    setOpenSnackbar(false);
  };

  const handleLogin = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    authenticate(dispatch, data.get("email"), data.get("password"))
      .then((data) => {
        console.log("logged in, session still need to be verified");
        navigate("/");
        dispatch({ type: "NAVIGATE", payload: "/" });
      })
      .catch((err) => {
        console.error("Failed to login", err);
      });
  };

  const handleNewPassword = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    completeEnforcePasswordChange(dispatch, data.get("newPassword"), user)
      .then((data) => {
        console.log("Password change succeeded: ", data);
        navigate("/");
        dispatch({ type: "NAVIGATE", payload: "/" });
      })
      .catch((err) => {
        console.error("Password change failed: ", err);
        navigate("/login");
      });
  };

  const handleMFAVerification = (code) => {
    verifyMFA(dispatch, user, code)
      .then((data) => {
        console.log("MFA Verification succeeded: ", data)
        navigate("/");
        dispatch({ type: "NAVIGATE", payload: "/" });
      })
      .catch((err) => {
        console.error("MFA Verification failed: ", err);
        navigate("/login");
      });
  };

  // TODO: refactor this code
  if (loading) {
    return (
      <Box
        sx={{
          alignItems: "center",
          justifyContent: "center",
          position: "fixed", // The element is positioned relative to the browser window
          top: "50%", // Move it down to 50% of the height
          left: "50%", // Move it right to 50% of the width
          transform: "translate(-50%, -50%)", // This is to offset the spinner's own height and width
        }}
      >
        <LoadingPage />
      </Box>
    );
  }

  return (
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        {openSnackbar && (
          <Alert severity="error" onClose={handleCloseSnackbar}>
            {errorMessage}
          </Alert>
        )}
        {newPasswordRequired ? (
          <ChangeDefaultPasswordForm onSubmit={handleNewPassword} />
        ) : mfaRequired ? (
          <MFAVerificationForm onSubmit={handleMFAVerification} />
        ) : (
          <LoginForm onSubmit={handleLogin} />
        )}

        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
        {getEnvironmentFromBackendUrl(process.env.REACT_APP_BACKEND_URL) === "dev" && <Banner />}
      </Container>
  );
}
